const routes = {
  updateProfile: 'profile',
};

export default routes